import * as React from 'react';

interface TFFCardProps {
  children: React.ReactNode;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  elevated?: boolean;
  level?: '1' | '2' | '3' | '4' | '5';
  extraClassName?: string;
  extraStyle?: React.CSSProperties;
}

export const TFFCard: React.FC<TFFCardProps> = ({
  children,
  size = 'xs',
  elevated = true,
  level = '5',
  extraClassName,
  extraStyle,
}) => {
  const elevatedClass = elevated ? `elevated level-${level}` : '';
  const extraClass = extraClassName || '';
  const className = ['card', size, elevatedClass, extraClass].filter(Boolean).join(' ');

  return (
    <div className={className} style={extraStyle}>
      {children}
    </div>
  );
};

export default TFFCard;
